import { render, staticRenderFns } from "./GlobalOverlay.vue?vue&type=template&id=22fde1e3&"
import script from "./GlobalOverlay.vue?vue&type=script&lang=js&"
export * from "./GlobalOverlay.vue?vue&type=script&lang=js&"
import style0 from "./GlobalOverlay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports